import config from "./config"

export let hostname = window?.location.hostname;

export default config;
